import { render, staticRenderFns } from "./PersonalProfesionalizacion.vue?vue&type=template&id=7f2a56aa&scoped=true"
import script from "./PersonalProfesionalizacion.vue?vue&type=script&lang=js"
export * from "./PersonalProfesionalizacion.vue?vue&type=script&lang=js"
import style0 from "./PersonalProfesionalizacion.vue?vue&type=style&index=0&id=7f2a56aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a56aa",
  null
  
)

export default component.exports